import React from 'react';
import PropTypes from "prop-types";
import ReactCrop from 'react-image-crop';
import PictureCropUtils from './PictureCropUtils';

export default class PictureCrop extends React.Component {

    static defaultProps = {
        aspect              : 1,
        onChange            : () => {}
    };

    static propTypes = {
        picture             : PropTypes.object.isRequired,
        pictureUri          : PropTypes.string.isRequired,
        aspect              : PropTypes.number.isRequired,
        onChange            : PropTypes.func,
        minCropWidth        : PropTypes.number
    };

    constructor(props) {
        super(props);
        this.state = this.initialState();
        this.cropperRef = undefined;
    }

    initialState = () => {
        return {
            crop: undefined,
            cropInPixel: undefined,
            imageLoaded: false,
            imageWidth: undefined,
            imageHeight: undefined
        }
    };

    getNaturalHeight = () => this.cropperRef.imageRef.naturalHeight;
    getNaturalWidth = () => this.cropperRef.imageRef.naturalWidth;

    setInitialCrop = () => {
        // Adjust crop to have nice values
        let adjustedCropCoordinates = PictureCropUtils.adjustCropCoordinates(this.props.picture.cropCoordinates, this.props.aspect, this.props.picture.width, this.props.picture.height);
        let cropInPixel = this._coordinatesToCropPixel(adjustedCropCoordinates, this.props.picture);
        let naturalHeight = this.getNaturalHeight();
        let naturalWidth = this.getNaturalWidth();

        let crop = this._pixelToPercentage(cropInPixel, naturalHeight, naturalWidth);

        this.setState({
            cropInPixel: cropInPixel,
            crop: crop,
            imageWidth: naturalWidth,
            imageHeight: naturalHeight
        }, this.onChange);
    };

    onImageLoaded = () => {
        this.setState({
            imageLoaded: true
        }, this.setInitialCrop);
    };

    onCompleteCrop = (crop) => this._setCrop(crop);
    onChange = () => this.props.onChange(this.state.cropInPixel, this.isValidCrop());

    _setCrop = (crop) => {
        this.setState({
            cropInPixel: this._percentageToPixel(crop, this.state.imageHeight, this.state.imageWidth),
            crop: crop
        }, this.onChange);
    };

    _coordinatesToCropPixel = (cropCoordinates) => {
        let x2 = cropCoordinates[2];
        let y2 = cropCoordinates[3];
        if(cropCoordinates[2] === 0 && cropCoordinates[3] === 0){
            x2 = 100;
            y2 = 100;
        }
        return{
            x1: cropCoordinates[0],
            y1: cropCoordinates[1],
            x2: x2,
            y2: y2,
            h: y2 - cropCoordinates[1],
            w: x2 - cropCoordinates[0]
        }
    };

    _percentageToPixel = (crop) => {
        let naturalHeight = this.state.imageHeight;
        let naturalWidth = this.state.imageWidth;
        let cropHeightInPixel = Math.round(naturalHeight * (crop.height / 100 ));
        let cropWidthInPixel = Math.round(naturalWidth * (crop.width / 100 ));
        let cropXInPixel = Math.round(naturalWidth * (crop.x / 100 ));
        let cropYInPixel = Math.round(naturalHeight * (crop.y / 100 ));

        return {
            x1: cropXInPixel,
            y1: cropYInPixel,
            h: cropHeightInPixel,
            w: cropWidthInPixel,
            x2: cropXInPixel + cropWidthInPixel,
            y2: cropYInPixel + cropHeightInPixel,
            width: naturalWidth,
            height: naturalHeight
        }
    };

    _pixelToPercentage = (cropInPixel, naturalHeight, naturalWidth) => {
        if(naturalHeight <= 0|| naturalWidth <= 0){
            return {}
        }
        let cropHeight = (cropInPixel.h / naturalHeight) * 100;
        let cropWidth = (cropInPixel.w / naturalWidth) * 100;
        let cropX = (cropInPixel.x1 / naturalWidth) * 100;
        let cropY = (cropInPixel.y1 / naturalHeight) * 100;
        let aspect = this.props.aspect;

        return {
            x: cropX,
            y: cropY,
            height: cropHeight,
            width: cropWidth,
            aspect: aspect
        }
    };

    isValidCrop = () => this.state.cropInPixel && this.state.cropInPixel.h >= 0 && this.state.cropInPixel.w >= this.props.minCropWidth;

    render = () => (
        <div className="u-img-center">
            <ReactCrop
                ref={ref => this.cropperRef = ref}
                src={this.props.pictureUri}
                minWidth={this.props.minCropWidth}
                keepSelection
                crop={this.state.crop}
                onImageLoaded={this.onImageLoaded}
                onChange={this.onCompleteCrop}
                crossorigin="use-credentials"
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./js/mywort/commons/components/picture-upload-crop/PictureCrop.jsx